import React from "react";

const ColumnHeader = ({title, show_title}) => {
  return (
    <div className="dashboard-column-header">
      {!!show_title && <h6 className="dashboard-column-header-label">{title}</h6>}
    </div>
  )
}

export default React.memo(ColumnHeader);
